namespace TabAurous.OMS {
    export interface ProductTypeForm {
        ItemId: Serenity.LookupEditor;
        ItemTypeId: Serenity.LookupEditor;
        ProductTypeCode: Serenity.StringEditor;
        ProductTypeName: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        SalesCostMethodId: Serenity.EnumEditor;
        PurchaseCostMethodId: Serenity.EnumEditor;
        Purity: Serenity.DecimalEditor;
    }

    export class ProductTypeForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ProductType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductTypeForm.init)  {
                ProductTypeForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ProductTypeForm, [
                    'ItemId', w0,
                    'ItemTypeId', w0,
                    'ProductTypeCode', w1,
                    'ProductTypeName', w1,
                    'HSN', w0,
                    'TaxCode', w0,
                    'SalesCostMethodId', w2,
                    'PurchaseCostMethodId', w2,
                    'Purity', w3
                ]);
            }
        }
    }
}
